import request from '@/utils/request'

let AgentApi = {
  getRefreshWxUrl (data, errorback) {
    return request._post('/supplier/agent/refreshUrl', data, errorback)
  },
  getProductCodeWxUrl (data, errorback) {
    return request._post('/supplier/agent/product/wxUrl', data, errorback)
  },
}
export default AgentApi



// WEBPACK FOOTER //
// ./src/api/agent.js